import { render, staticRenderFns } from "./ProblemList.vue?vue&type=template&id=e65ff64e"
import script from "./ProblemList.vue?vue&type=script&lang=js"
export * from "./ProblemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports